import { render, staticRenderFns } from "./product-detail.vue?vue&type=template&id=7b61920e&scoped=true"
import script from "./product-detail.vue?vue&type=script&lang=js"
export * from "./product-detail.vue?vue&type=script&lang=js"
import style0 from "./product-detail.vue?vue&type=style&index=0&id=7b61920e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b61920e",
  null
  
)

export default component.exports